
import React from 'react';
import { Button } from '@/components/ui/button';
import { Plus } from 'lucide-react';
import { toast } from 'sonner';

interface CategoryActionsSectionProps {
  onAddCategory: () => void;
  onExpandAll: () => void;
  onCollapseAll: () => void;
}

export const CategoryActionsSection: React.FC<CategoryActionsSectionProps> = ({
  onAddCategory,
  onExpandAll,
  onCollapseAll,
}) => {
  return (
    <div className="flex justify-between items-center mb-4">
      <Button 
        onClick={onAddCategory}
        className="bg-[#FF6D00] text-white hover:bg-[#FF6D00]/90"
      >
        <Plus className="mr-2 h-4 w-4" />
        Add Category
      </Button>
      
      <div className="flex gap-2">
        <button
          onClick={onExpandAll}
          className="px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
        >
          Expand All
        </button>
        <button
          onClick={onCollapseAll}
          className="px-3 py-1 text-sm bg-gray-100 hover:bg-gray-200 rounded-md transition-colors"
        >
          Collapse All
        </button>
      </div>
    </div>
  );
};
